/**
 *	scripts/Navigation-Component.js
 */

window.navigationComponent = function () {
  const body = document.querySelector('body');
  const close = document.querySelector('.Navigation-Component .close');

  close.addEventListener('click', function () {
    body.classList.toggle('nav-active');
  });
};
